// Renaming and re-dressing a journal. Ported from journals-web.jsx (EditJournalModal).

import { useState } from 'react';
import { JournalSheet } from './JournalSheet';
import { Cover } from './Cover';
import { CoverPicker } from './CoverPicker';
import type { Collection } from '../api/collections';

export interface JournalEdits {
  title: string;
  subtitle: string;
  coverId: string;
}

export function EditJournalSheet({
  collection,
  onClose,
  onSave,
}: {
  collection: Collection;
  onClose(): void;
  onSave(edits: JournalEdits): void;
}) {
  const [title, setTitle] = useState(collection.title);
  const [subtitle, setSubtitle] = useState(collection.subtitle);
  const [coverId, setCoverId] = useState(collection.coverId);

  const save = () =>
    onSave({
      // An emptied title keeps the old one rather than leaving a nameless notebook on the shelf.
      title: title.trim() || collection.title,
      subtitle: subtitle.trim(),
      coverId,
    });

  return (
    <JournalSheet title="Edit journal" confirmLabel="Save" onConfirm={save} onClose={onClose}>
      <div className="csheet-scroll">
        <div className="nc-preview">
          <Cover
            cover={coverId}
            title={title.trim() || 'Untitled journal'}
            subtitle={subtitle.trim()}
            size="lg"
          />
        </div>

        <div className="nc-field">
          <label className="nc-label" htmlFor="edit-journal-title">
            Title
          </label>
          <input
            id="edit-journal-title"
            className="nc-in big"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Journal title"
          />
        </div>

        <div className="nc-field">
          <label className="nc-label" htmlFor="edit-journal-subtitle">
            Subtitle <span className="hint">optional</span>
          </label>
          <input
            id="edit-journal-subtitle"
            className="nc-in"
            value={subtitle}
            onChange={(e) => setSubtitle(e.target.value)}
            placeholder="March 2026"
          />
        </div>

        <CoverPicker coverId={coverId} onPick={setCoverId} />
        <div style={{ height: 20 }} />
      </div>
    </JournalSheet>
  );
}
